module.exports = __webpack_public_path__ + "img/city.59ab8a6e.svg";